import React, { useMemo, useState, useEffect } from 'react'

/**
 * Pré-visualização de PDF com zoom (fragmento #zoom= do viewer nativo).
 */
const PdfPreviewPanel = ({ url, label, onClose }) => {
  const [zoom, setZoom] = useState(100)

  useEffect(() => {
    setZoom(100)
  }, [url])

  const src = useMemo(() => {
    if (!url) return null
    const base = String(url).split('#')[0]
    return `${base}#toolbar=1&navpanes=0&zoom=${zoom}`
  }, [url, zoom])

  return (
    <div
      style={{
        flex: 1,
        minHeight: 280,
        border: '1px solid #e2e8f0',
        borderRadius: 8,
        overflow: 'hidden',
        background: '#0f172a08',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-2"
        style={{
          minHeight: 36,
          borderBottom: '1px solid #e2e8f0',
          background: '#f8fafc',
          fontSize: 12,
          gap: 8,
        }}
      >
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {label ? `Pré-visualização: ${label}` : 'Pré-visualização do PDF'}
        </span>

        {url && (
          <div className="d-flex align-items-center" style={{ gap: 4 }}>
            <button
              type="button"
              className="btn btn-sm btn-light py-0 px-2"
              title="Diminuir zoom"
              disabled={zoom <= 50}
              onClick={() => setZoom((z) => Math.max(50, z - 25))}
            >
              −
            </button>
            <span style={{ minWidth: 44, textAlign: 'center', fontWeight: 600 }}>{zoom}%</span>
            <button
              type="button"
              className="btn btn-sm btn-light py-0 px-2"
              title="Aumentar zoom"
              disabled={zoom >= 300}
              onClick={() => setZoom((z) => Math.min(300, z + 25))}
            >
              +
            </button>
            <button
              type="button"
              className="btn btn-sm btn-light py-0 px-2"
              title="Ajustar à largura"
              onClick={() => setZoom(100)}
            >
              100%
            </button>
            {onClose && (
              <button
                type="button"
                className="btn btn-link btn-sm p-0 ml-1"
                style={{ fontSize: 11 }}
                onClick={onClose}
              >
                Fechar
              </button>
            )}
          </div>
        )}
      </div>

      {src ? (
        <iframe
          key={src}
          title="preview-pdf"
          src={src}
          style={{ flex: 1, width: '100%', border: 0, background: '#fff' }}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center text-muted"
          style={{ flex: 1, fontSize: 13 }}
        >
          Selecione ou anexe um PDF para visualizar aqui
        </div>
      )}
    </div>
  )
}

export default PdfPreviewPanel
